import { FrameBody, Warning, WarningProps} from "@npd-ng/adp-benchmark";
import { Views} from "../types";
import { Content } from "../types/Content";
import { useStateContext } from "../hooks/useStateContext";
import { useResolveServiceStatus } from "../hooks/useNetworkService";
import { actions } from "../state";
import { useState } from "react";
import ConnectionCheckView from "./ConnectionCheckView";
import { AppStateProvider } from "../state/Provider";
export default function WarningView() {
  const { state, dispatch } = useStateContext();
  const {checkNCSeServerAvailability, checkOnlineServerAvailability} = useResolveServiceStatus(dispatch);
  const [wait, setWait] = useState(false);
  const content= state.staticContent as Content;
  const type = state.deviceReadinessState.validationError || "SystemError";
  const deviceReadiness =content.deviceReadiness[type]
  const lastView: Views = state.sessionState.lastKnownGoodState
  const actionsContent = content.actions;
  const onTryAgain =()=>{
    setWait(true);
    setTimeout(()=>{
      const provider = AppStateProvider.getInstance();
      const state = provider.getState();
      if(state.sessionState.selectedAssessmentMode === "online"){
        
        checkOnlineServerAvailability().then((isOnline:boolean)=>{
          setWait(false);
           if(isOnline){
            dispatch(actions.createSetViewAction(lastView));
           }
        })
     }
     else if(state.sessionState.selectedAssessmentMode === "ncs"){
       checkNCSeServerAvailability().then((isConnected:boolean)=>{
        setWait(false);
         if(isConnected){
          dispatch(actions.createSetViewAction(lastView));
         }
      })
     }
    },2000)
  }
  const warningProps: WarningProps = {
      errorCode: deviceReadiness.code,
      title: deviceReadiness.title,
      message: deviceReadiness.message,
      buttons:[{
        label: actionsContent.tryAgain,
        action:onTryAgain,
        variant: "primary"
    },{
          label: actionsContent.cancel,
          action:()=>{dispatch(actions.createSetViewAction("ModeSelectionsView"))},
          variant: "secondary"
      }, ]
    }
  return (
    <> {wait ?  <ConnectionCheckView/> :
       <FrameBody>
         <Warning {...warningProps}/>
       </FrameBody>
  }
   </>
  )
}
